import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import React from 'react';
import LoginBnSmall from './LoginBnSmall';

export default function Header() {
  return (
    <Navbar
      bg="light"
      sticky="top"
      expand="lg" // Makes the navbar responsive (collapsible for small screens)
      className="navbar navbar-scroll shadow-0 border-bottom border-dark bg-white"
    >
      <Container>
        {/* Brand Name */}
        <a className="navbar-brand print" id="print" href="/">
          <b>Babyboo.dev</b>
        </a>

        {/* Navbar Toggler for Mobile */}
        <Navbar.Toggle
          aria-controls="navbarSupportedContent"
          className="navbar-toggler"
        >
          <i className="fas fa-bars" aria-hidden="true"></i>
        </Navbar.Toggle>

        {/* Collapsible Navbar Items */}
        <Navbar.Collapse id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto text-end">
            <li className="nav-item">
              <a className="nav-link" href="/stories">
               ✨Create your Story
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/">
              🎨Create a coloring page
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/aboutus/">
                About Us
              </a>
            </li>
          </ul>
        </Navbar.Collapse>

        {/* Login Section */}
        <div className="d-flex align-items-center ms-3">
          <LoginBnSmall />
        </div>
      </Container>
    </Navbar>

  );
}